import Image from 'next/image';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledNavbarAvatar = styled.button<{ isBackgroundHidden: boolean }>`
	${(p) => css`
		width: 50px;
		height: 50px;

		border: 1px solid ${p.theme.colors.gold};

		border-radius: 50%;

		padding: 1px;
		padding-top: 6px;

		display: flex;
		justify-content: center;
		align-items: center;

		background-color: transparent;

		cursor: pointer;

		overflow: hidden;

		${mq(
			EMediaQuery.md,
			`
			border: 2px solid ${p.theme.colors.gold};
			width: 80px;
			height: 80px;

			
			${!p.isBackgroundHidden ? `background-color: ${p.theme.colors.black};` : `background-color: ${p.theme.colors.black}AA;`}
			`
		)}

		&::before {
			content: ' ';
			position: absolute;
			top: 3px;
			left: 3px;
			right: 3px;
			bottom: 3px;
			z-index: 10;

			border: 1px solid ${p.theme.colors.gold};
			border-radius: 50%;

			${mq(
				EMediaQuery.md,
				`
			top: 3px;
			left: 3px;
			right: 3px;
			bottom: 3px;
		`
			)}
		}
		&::after {
			content: ' ';
			position: absolute;
			top: 1px;
			left: 1px;
			right: 1px;
			bottom: 1px;
			z-index: 10;

			border: 2px solid ${p.theme.colors.black};
			border-radius: 50%;

			${mq(
				EMediaQuery.md,
				`
			top: 1px;
			left: 1px;
			right: 1px;
			bottom: 1px;
		`
			)}
		}
	`}
`;

export const StyledAvatarFace = styled.div`
	position: relative;
	z-index: 9;

	width: 200%;
	height: 200%;
	border-radius: 50%;

	overflow: hidden;

	background-color: ${(p) => p.theme.colors.black};
`;

export const ImageEx = styled(Image)<{ layer: number }>`
	position: absolute;
	${({ layer }) => (layer ? `z-index: ${layer};` : '')}
`;

export const StyledImageContainer = styled.div`
	margin-top: -1px;

	width: 20px;
	height: 30px;

	${mq(EMediaQuery.md, 'width: 35px; height: 50px;')}
`;
